/* eslint-disable indent */
import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'
import { Box } from '@chakra-ui/react'

import CustomIcon from '../../CustomIcon'

interface CustomIconProps extends IconProps {
  variant?: string
  color?: string
}

const StomachIconOutline = createIcon({
  displayName: 'StomachIconOutline',
  viewBox: '0 0 24 24',
  path: (
    <>
      <path
        d="M21 13v-1c0-3.866-3.134-7-7-7h-1c-.884 0-1.633-.573-1.898-1.368 -.131-.395-.538-.632-.953-.632h-1.017c-.652 0-1.137.618-.974 1.249 .337 1.307 1.191 2.405 2.329 3.068 .305.178.513.478.513.831 0 1.499 0 5.438 0 5.438 0 .781-.633 1.414-1.414 1.414 -.375 0-.735-.149-1-.414l-.757-.757c-.815-.815-2.077-1.081-3.211-.56 -1.02.468-1.618 1.551-1.618 2.673v3.058c0 .828.672 1.5 1.5 1.5 .828 0 1.5-.672 1.5-1.5v-2l2.106 2.106c1.213 1.213 2.857 1.894 4.572 1.894v0c4.596 0 8.322-3.726 8.322-8.322"
        strokeLinecap="round"
        strokeWidth="1.5"
        stroke="currentColor"
        fill="none"
        strokeLinejoin="round"
      ></path>
      <path fill="none" d="M0 0h24v24h-24v-24Z"></path>
    </>
  ),
})

const StomachIconTwoTone = createIcon({
  displayName: 'StomachIconTwoTone',
  viewBox: '0 0 24 24',
  path: (
    <>
      <Box
        as="path"
        d="M21 13v-1c0-3.866-3.134-7-7-7h-1c-.884 0-1.633-.573-1.898-1.368 -.131-.395-.538-.632-.953-.632h-1.017c-.652 0-1.137.618-.974 1.249 .337 1.307 1.191 2.405 2.329 3.068 .305.178.513.478.513.831 0 1.499 0 5.438 0 5.438 0 .781-.633 1.414-1.414 1.414 -.375 0-.735-.149-1-.414l-.757-.757c-.815-.815-2.077-1.081-3.211-.56 -1.02.468-1.618 1.551-1.618 2.673v3.058c0 .828.672 1.5 1.5 1.5 .828 0 1.5-.672 1.5-1.5v-2l2.106 2.106c1.213 1.213 2.857 1.894 4.572 1.894v0c4.596 0 8.322-3.726 8.322-8.322"
        strokeLinecap="round"
        strokeWidth="1.5"
        stroke="twoToneStrokeColor"
        fill="twoToneFillColor"
        strokeLinejoin="round"
      ></Box>
    </>
  ),
})

const Stomach: FC<CustomIconProps> = (props) => {
  switch (props.variant || 'outline') {
    case 'twoTone':
      return <CustomIcon as={StomachIconTwoTone} {...props} />
    default:
      return <CustomIcon as={StomachIconOutline} {...props} />
  }
}

export default memo(Stomach)
